import { apiRequest } from '@/utils/api-request';

export interface ModelCost {
  model: string;
  base_cost_usd: number;
  marked_up_cost_usd: number;
}

export interface ProviderCost {
  provider: string;
  base_cost_usd: number;
  marked_up_cost_usd: number;
  models: ModelCost[];
}

export interface OrgCost {
  org_id: string;
  org_name: string | null;
  cost_available: boolean;
  markup_percentage: number;
  base_cost_usd: number;
  marked_up_cost_usd: number;
  margin_usd: number;
  providers: ProviderCost[];
}

export interface CrossOrgCostResponse {
  start_date: string;
  end_date: string;
  orgs: OrgCost[];
  totals: {
    base_cost_usd: number;
    marked_up_cost_usd: number;
    margin_usd: number;
  };
}

export async function getCrossOrgCost(params?: {
  start_date?: string;
  end_date?: string;
}): Promise<CrossOrgCostResponse> {
  const query = new URLSearchParams();
  if (params?.start_date) query.set('start_date', params.start_date);
  if (params?.end_date) query.set('end_date', params.end_date);
  const qs = query.toString();

  const response = await apiRequest<CrossOrgCostResponse>({
    url: `/admin/cost/by-org${qs ? `?${qs}` : ''}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) throw new Error(response.detail);
  if (!response.data) throw new Error('Failed to fetch cross-org cost');
  return response.data;
}
